import { settingApi } from 'src/pages/setting/slice/settingApi';

import type { LifecycleStage } from '../types/lifecycle.types';

const LIFECYCLE_API = {
  list: 'api/lifecycle-stages/list',
  add: 'api/lifecycle-stages',
  update: 'api/lifecycle-stages/',
  delete: 'api/lifecycle-stages/',
};

export const lifecycleApi = settingApi.injectEndpoints({
  endpoints: (builder) => ({
    // ----------------------------------------------------------------------
    // NOTE FOR DEVELOPERS:
    // Please maintain the following order for endpoints ensuring CRUD consistency:
    // 1. List (Filter)
    // 2. Create
    // 3. Update
    // 4. Delete
    // ----------------------------------------------------------------------

    filterLifecycle: builder.mutation({
      query: (filter) => ({
        url: LIFECYCLE_API.list,
        method: 'POST',
        body: filter,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: {
        data?: {
          list?: any[];
          total?: number;
        };
      }) => {
        const stages =
          response?.data?.list?.map((stage: any, index: number) => ({
            id: stage.id ?? '',
            name: stage.name ?? '',
            description: stage.description ?? '',
            order: stage.order !== null ? stage.order : index,
            type: stage.type ?? '',
            default: stage.default ?? false,
            isDeletable: stage.isDeletable ?? false,
            emoji: stage.emoji ?? ' ',
            createdAt: stage.createdAt ?? '',
            contacts: stage.contacts ?? [],
            conversations: stage.conversations ?? [],
          })) ?? [];

        return {
          list: stages,
          total: response?.data?.total ?? 0,
        };
      },
    }),

    createLifecycle: builder.mutation<any, { lifecycle: any[] }>({
      query: (data) => ({
        url: LIFECYCLE_API.add,
        method: 'POST',
        body: data,
      }),
    }),

    updateLifecycle: builder.mutation<
      LifecycleStage,
      { id: string; updates: Partial<LifecycleStage> }
    >({
      query: ({ id, updates }) => ({
        url: `${LIFECYCLE_API.update}${id}`,
        method: 'PUT',
        body: updates,
      }),
    }),

    deleteLifecycle: builder.mutation({
      query: (id: string) => ({
        url: `${LIFECYCLE_API.delete}${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useFilterLifecycleMutation,
  useCreateLifecycleMutation,
  useUpdateLifecycleMutation,
  useDeleteLifecycleMutation,
} = lifecycleApi;
